import { React, useState, useEffect } from "react";
import { Row, Col, Card, Button, Offcanvas } from "react-bootstrap";
import { cloudServiceAPI } from "../API/cloudAPI";
import { digitalServiceAPI ,digitalAPI,dynamicDigitalServiceAPI} from "../API/digitalAPI";
import { smartServiceAPI,DynamicsmartServiceAPI } from "../API/smartAPI";
import { technologyServiceAPI } from "../API/technologyAPI";
import { motion } from "framer-motion";

const SubHeaderService = () => {
  const [serviceContentData, setServiceContentData] = useState([]);
  const [servicesubContentData, setServicesubContentData] = useState([]);
  const [show, setShow] = useState(false);
  const [canvasTitle, setCanvasTitle] = useState();
  const [canvasDesc, setCanvasDesc] = useState();
  const handleClose = () => setShow(false);
  const handleShow = (count, index) => {
    setShow(true);
    const popcontentover = servicesubContentData[count];
    const popcontent = popcontentover[index];
    const datatext = popcontent.ElementDescription;
    const datatitle = popcontent.ElementSubTitleValue;
    setCanvasDesc(datatext);
    setCanvasTitle(datatitle);
  };
  const businessTextAnimate = {
    offscreen: { y: 50, opacity: 0 },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        ease: "easeInOut",
        bounce: 0.4,
        duration: 3,
      },
    },
  };

  useEffect(() => {
    var config = { "Access-Control-Allow-Origin": "*" };
    if (window.location.href.includes("smart") === true) {
      smartServiceAPI(
        config,
        (response) => {
          //success
          // console.log("response", response.data);
          const serviceElement = response.data.map(
            (item) => item.contentElements
          );
          const servicealldata = response.data[0].contentElements;
          const innerdata = [];
          setServiceContentData(serviceElement[0]);
          //  console.log("serviceElement", servicealldata);
          for (let i = 0; i < servicealldata.length; i++) {
            innerdata.push(servicealldata[i].ElementSubTitle);
          }
          // console.log("service inner layer data---------",innerdata);
          setServicesubContentData(innerdata);
        },
        (err) => {
          //error
          console.log(err);
        }
      );
    }

    if (window.location.href.includes("devops") === true) {
      DynamicsmartServiceAPI(
        config,
        (response) => {
          //success
          // console.log("response", response.data);
          const serviceElement = response.data.map(
            (item) => item.contentElements
          );
          const servicealldata = response.data[0].contentElements;
          const innerdata = [];
          setServiceContentData(serviceElement[0]);
          //  console.log("serviceElement", servicealldata);
          for (let i = 0; i < servicealldata.length; i++) {
            innerdata.push(servicealldata[i].ElementSubTitle);
          }
          // console.log("service inner layer data---------",innerdata);
          setServicesubContentData(innerdata);
        },
        (err) => {
          //error
          console.log(err);
        },
        'getPage4Block7'
      );
    }

 
    if (window.location.href.includes("analytics") === true) {
      DynamicsmartServiceAPI(
        config,
        (response) => {
          //success
          // console.log("response", response.data);
          const serviceElement = response.data.map(
            (item) => item.contentElements
          );
          const servicealldata = response.data[0].contentElements;
          const innerdata = [];
          setServiceContentData(serviceElement[0]);
          //  console.log("serviceElement", servicealldata);
          for (let i = 0; i < servicealldata.length; i++) {
            innerdata.push(servicealldata[i].ElementSubTitle);
          }
          // console.log("service inner layer data---------",innerdata);
          setServicesubContentData(innerdata);
        },
        (err) => {
          //error
          console.log(err);
        },
        'getPage4Block5'
      );
    }

    if (window.location.href.includes("automations") === true) {
      DynamicsmartServiceAPI(
        config,
        (response) => {
          //success
          // console.log("response", response.data);
          const serviceElement = response.data.map(
            (item) => item.contentElements
          );
          const servicealldata = response.data[0].contentElements;
          const innerdata = [];
          setServiceContentData(serviceElement[0]);
          //  console.log("serviceElement", servicealldata);
          for (let i = 0; i < servicealldata.length; i++) {
            innerdata.push(servicealldata[i].ElementSubTitle);
          }
          // console.log("service inner layer data---------",innerdata);
          setServicesubContentData(innerdata);
        },
        (err) => {
          //error
          console.log(err);
        },
        'getPage4Block6'
      );
    }
    
    // else if (window.location.href.includes("digital") === true) {
    //   digitalServiceAPI(
    //     config,
    //     (response) => {
    //       //success
    //       // console.log("response", response.data);
    //       const serviceElement = response.data.map(
    //         (item) => item.contentElements
    //       );
    //       const servicealldata = response.data[0].contentElements;
    //       const innerdata = [];
    //       setServiceContentData(serviceElement[0]);
    //       // console.log("serviceElement", servicealldata);
    //       for (let i = 0; i < servicealldata.length; i++) {
    //         innerdata.push(servicealldata[i].ElementSubTitle);
    //       }

    //       setServicesubContentData(innerdata);
    //     },
    //     (err) => {
    //       //error
    //       console.log(err);
    //     }
    //   );
    // }intelligent
    else if (window.location.href.includes("digitalcms") === true) {
      digitalServiceAPI(
        config,
        (response) => {
          //success
          // console.log("response", response.data);
          const serviceElement = response.data.map(
            (item) => item.contentElements
          );
          const servicealldata = response.data[0].contentElements;
          const innerdata = [];
          setServiceContentData(serviceElement[0]);
          // console.log("serviceElement", servicealldata);
          for (let i = 0; i < servicealldata.length; i++) {
            innerdata.push(servicealldata[i].ElementSubTitle);
          }

          setServicesubContentData(innerdata);
        },
        (err) => {
          //error
          console.log(err);
        }
      );
    }
    else if (window.location.href.split("/")[3] === "ecommerce") {
      
      digitalAPI(
        config,
        (response) => {
          //success
          // console.log("response", response.data);
          const serviceElement = response.data.map(
            (item) => item.contentElements
          );
          const servicealldata = response.data[0].contentElements;
          const innerdata = [];
          setServiceContentData(serviceElement[0]);
          // console.log("serviceElement", servicealldata);
          for (let i = 0; i < servicealldata.length; i++) {
            innerdata.push(servicealldata[i].ElementSubTitle);
          }

          setServicesubContentData(innerdata);
        },
        (err) => {
          //error
          console.log(err);
        },
        'getPage5Block6'
      );
    }

    else if (window.location.href.includes("intelligent") === true) {
      
      digitalAPI(
        config,
        (response) => {
          //success
          // console.log("response", response.data);
          const serviceElement = response.data.map(
            (item) => item.contentElements
          );
          const servicealldata = response.data[0].contentElements;
          const innerdata = [];
          setServiceContentData(serviceElement[0]);
          // console.log("serviceElement", servicealldata);
          for (let i = 0; i < servicealldata.length; i++) {
            innerdata.push(servicealldata[i].ElementSubTitle);
          }

          setServicesubContentData(innerdata);
        },
        (err) => {
          //error
          console.log(err);
        },
        'getPage19Block3'
      );
    }

    else if (window.location.href.includes("mobility") === true) {
      
      digitalAPI(
        config,
        (response) => {
          //success
          // console.log("response", response.data);
          const serviceElement = response.data.map(
            (item) => item.contentElements
          );
          const servicealldata = response.data[0].contentElements;
          const innerdata = [];
          setServiceContentData(serviceElement[0]);
          // console.log("serviceElement", servicealldata);
          for (let i = 0; i < servicealldata.length; i++) {
            innerdata.push(servicealldata[i].ElementSubTitle);
          }

          setServicesubContentData(innerdata);
        },
        (err) => {
          //error
          console.log(err);
        },
        'getPage5Block7'
      );
    }

    else if (window.location.href.includes("uiux") === true) {
      
      digitalAPI(
        config,
        (response) => {
          //success
          // console.log("response", response.data);
          const serviceElement = response.data.map(
            (item) => item.contentElements
          );
          const servicealldata = response.data[0].contentElements;
          const innerdata = [];
          setServiceContentData(serviceElement[0]);
          // console.log("serviceElement", servicealldata);
          for (let i = 0; i < servicealldata.length; i++) {
            innerdata.push(servicealldata[i].ElementSubTitle);
          }

          setServicesubContentData(innerdata);
        },
        (err) => {
          //error
          console.log(err);
        },
        'getPage5Block10'
      );
    }

    else if (window.location.href.includes("technologies") === true) {
      
      digitalAPI(
        config,
        (response) => {
          //success
          // console.log("response", response.data);
          const serviceElement = response.data.map(
            (item) => item.contentElements
          );
          const servicealldata = response.data[0].contentElements;
          const innerdata = [];
          setServiceContentData(serviceElement[0]);
          // console.log("serviceElement", servicealldata);
          for (let i = 0; i < servicealldata.length; i++) {
            innerdata.push(servicealldata[i].ElementSubTitle);
          }

          setServicesubContentData(innerdata);
        },
        (err) => {
          //error
          console.log(err);
        },
        'getPage5Block9'
      );
    }
    else if (window.location.href.includes("lms") === true) {
      
      digitalAPI(
        config,
        (response) => {
          //success
          // console.log("response", response.data);
          const serviceElement = response.data.map(
            (item) => item.contentElements
          );
          const servicealldata = response.data[0].contentElements;
          const innerdata = [];
          setServiceContentData(serviceElement[0]);
          // console.log("serviceElement", servicealldata);
          for (let i = 0; i < servicealldata.length; i++) {
            innerdata.push(servicealldata[i].ElementSubTitle);
          }

          setServicesubContentData(innerdata);
        },
        (err) => {
          //error
          console.log(err);
        },
        'getPage5Block11'
      );
    }
    
    else if (window.location.href.includes("technology") === true) {
      technologyServiceAPI(
        config,
        (response) => {
          //success
          //  console.log("response", response.data);
          const serviceElement = response.data.map(
            (item) => item.contentElements
          );
          const servicealldata = response.data[0].contentElements;
          const innerdata = [];
          setServiceContentData(serviceElement[0]);
          // console.log("serviceElement", servicealldata);
          for (let i = 0; i < servicealldata.length; i++) {
            innerdata.push(servicealldata[i].ElementSubTitle);
          }
          // console.log("service inner layer data---------",innerdata);
          setServicesubContentData(innerdata);
        },
        (err) => {
          //error
          console.log(err);
        }
      );
    } else if (window.location.href.includes("cloud") === true) {
      cloudServiceAPI(
        config,
        (response) => {
          //success
          //  console.log("response", response.data);
          const serviceElement = response.data.map(
            (item) => item.contentElements
          );
          const servicealldata = response.data[0].contentElements;
          const innerdata = [];
          setServiceContentData(serviceElement[0]);
          // console.log("serviceElement", servicealldata);
          for (let i = 0; i < servicealldata.length; i++) {
            innerdata.push(servicealldata[i].ElementSubTitle);
          }
          // console.log("service inner layer data---------",innerdata);
          setServicesubContentData(innerdata);
        },
        (err) => {
          //error
          console.log(err);
        }
      );
    }
  }, []);
  return (
    <div id="service" className="service_block">
      <div className="bics-header-wrapper pt-5">
        <div className="container">
          <h2 className="bics-header robotoBold">OUR SERVICES</h2>
          {serviceContentData.map((item, count) => (
            <Row className="my-xl-4 my-md-4 my-3" key={count}>
              <motion.div
                initial={"offscreen"}
                whileInView={"onscreen"}
                viewport={{ once: false, amount: 0.1 }}
                transition={{ staggerChildren: 0.2 }}
              >
                <Col xl={12} lg={12} md={12} xs={12} className="text-center">
                  <h2 className="service_subtitle">{item.ElementTitle}</h2>
                  <Row className="justify-content-center">
                    {servicesubContentData[count].map((data, index) => (
                      <Col
                        xl={3}
                        lg={4}
                        md={6}
                        xs={12}
                        className="py-4"
                        key={index}
                      >
                        <Card
                          border="light"
                          className="p-4 card_service card_hover"
                        >
                          <img
                            src={
                              process.env.REACT_APP_BASE_URL + data.ElementLogo
                            }
                            height="35"
                            className="mx-auto mb-2"
                            alt="service_symbol"
                          />
                          <p className="service_text mb-2 mt-1">
                            {item.ElementTitle}
                          </p>
                          <p className="service_title">
                            {data.ElementSubTitleValue}
                          </p>
                          <motion.div
                            className="bics-animate"
                            variants={businessTextAnimate}
                          >
                            <p className="service_content mb-1">
                              {data.ElementDescription}
                            </p>
                            <Button
                              variant="success"
                              className="transparent_button"
                              onClick={() => handleShow(count, index)}
                            >
                              Know more
                            </Button>
                          </motion.div>

                          <hr className="mx-auto my-0 service_bottom_line" />
                        </Card>
                      </Col>
                    ))}
                  </Row>
                </Col>
              </motion.div>
            </Row>
          ))}
        </div>
      </div>
      <Offcanvas
        className="service_canvas"
        show={show}
        placement={"end"}
        onHide={handleClose}
        scroll={true}
        backdrop={true}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title className="mx-5 mx-auto">
            {canvasTitle}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="mx-5 mx-auto">{canvasDesc}</Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default SubHeaderService;
